module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.favs.length > 1) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('dl', [_c('dd', [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('favs')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preAnalise.proposal.fav),
      expression: "preAnalise.proposal.fav"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "favs",
      "aria-hidden": "true"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.preAnalise.proposal, "fav", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.montaQuestoes]
    }
  }, _vm._l((_vm.favs), function(fav) {
    return _c('option', {
      domProps: {
        "value": fav
      }
    }, [_vm._v(_vm._s(fav.name))])
  }), 0), _vm._v(" "), (_vm.errors.first('favs')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('favs')))]) : _vm._e()])])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-12",
    class: {
      'has-error-div': _vm.errors.first('respostaFAV')
    }
  }, [_c('table', {
    staticClass: "table b-table table-hover table-bordered b-table-stacked-md",
    attrs: {
      "role": "table"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', {
    attrs: {
      "role": "rowgroup"
    }
  }, [_vm._l((this.preAnalise.favAnswers), function(questao, index) {
    return _c('tr', {
      attrs: {
        "aria-rowindex": "1",
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "aria-colindex": "1",
        "data-label": "Número",
        "role": "cell"
      }
    }, [_c('div', [_vm._v(_vm._s(questao.favQuestion.questionNumber))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "aria-colindex": "2",
        "data-label": "Pergunta",
        "role": "cell"
      }
    }, [_c('div', [_vm._v(_vm._s(questao.favQuestion.question))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "aria-colindex": "3",
        "data-label": "Sim",
        "role": "cell"
      }
    }, [_c('div', [_c('label', {
      staticClass: "new-control new-control-radio",
      staticStyle: {
        "padding-top": "25px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (questao.conformity),
        expression: "questao.conformity"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "type": "radio",
        "name": "respostaFAV",
        "value": "YES"
      },
      domProps: {
        "checked": _vm._q(questao.conformity, "YES")
      },
      on: {
        "change": function($event) {
          return _vm.$set(questao, "conformity", "YES")
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "new-control-indicator"
    })])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "aria-colindex": "4",
        "data-label": "Não",
        "role": "cell"
      }
    }, [_c('div', [_c('label', {
      staticClass: "new-control new-control-radio",
      staticStyle: {
        "padding-top": "25px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (questao.conformity),
        expression: "questao.conformity"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "type": "radio",
        "name": "respostaFAV",
        "value": "NO"
      },
      domProps: {
        "checked": _vm._q(questao.conformity, "NO")
      },
      on: {
        "change": function($event) {
          return _vm.$set(questao, "conformity", "NO")
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "new-control-indicator"
    })])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "aria-colindex": "5",
        "data-label": "N/A",
        "role": "cell"
      }
    }, [_c('div', [_c('label', {
      staticClass: "new-control new-control-radio",
      staticStyle: {
        "padding-top": "25px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (questao.conformity),
        expression: "questao.conformity"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "type": "radio",
        "name": "respostaFAV",
        "value": "NA"
      },
      domProps: {
        "checked": _vm._q(questao.conformity, "NA")
      },
      on: {
        "change": function($event) {
          return _vm.$set(questao, "conformity", "NA")
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "new-control-indicator"
    })])])])])
  }), _vm._v(" "), (this.preAnalise.favAnswers.length === 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(" Nenhuma pergunta atribuída!")])]) : _vm._e()], 2)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Fichas de Auto Verificação - Seleção")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Ficha de Auto Verificação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {}, [_c('tr', [_c('th', {
    staticClass: "sorting text-center",
    staticStyle: {
      "text-align": "center",
      "width": "15%"
    },
    attrs: {
      "tabindex": "0",
      "aria-colindex": "1",
      "aria-label": "Click to sort Descending"
    }
  }, [_vm._v("Número")]), _vm._v(" "), _c('th', {
    staticClass: "sorting text-center",
    staticStyle: {
      "text-align": "center",
      "width": "50%"
    },
    attrs: {
      "tabindex": "0",
      "aria-colindex": "2",
      "aria-label": "Click to sort Descending"
    }
  }, [_vm._v("Pergunta")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center",
      "width": "6%"
    },
    attrs: {
      "aria-colindex": "3"
    }
  }, [_vm._v("Sim")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center",
      "width": "5%"
    },
    attrs: {
      "aria-colindex": "4"
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center",
      "width": "5%"
    },
    attrs: {
      "aria-colindex": "5"
    }
  }, [_vm._v("N/A")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-db94f5d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/fav.vue
// module id = 2094
// module chunks = 1